<template>
  <v-dialog class="" v-model="getDemoModeDialog.active" width="600" persistent>
    <v-card flat>
      <v-card-title class="title pt-5 px-5">
        {{ $t("components.demoModeDialog.demoBoat") }}
      </v-card-title>
      <v-card-text class="text px-5 pb-5">
        {{
          $t(
            "components.demoModeDialog.thisIsADemoBoatYouCanUseToDiscoverTheVariousFeaturesOfAConnectedBoat"
          )
        }}
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-btn
          block
          class="mb-4 pt-0 button button--text px-5"
          color="black"
          @click="handleClose"
        >
          {{ $t("components.demoModeDialog.keepExploring") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  // props: {
  //   dialog: { type: Object, default: { active: false } },
  // },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getDemoModeDialog"]),
  },
  methods: {
    handleClose() {
      this.$store.commit("setDemoModeDialogStatus", false);
    },
  },
};
</script>
<style scoped>
.button {
  text-transform: unset !important;
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  border-radius: 10px;
  height: 48px !important;
}
.button--text {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: white !important;
}
.title {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #1e1e1e;
}
.text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #646464;
}
</style>
